import type { HTMLAttributes } from 'react';

/**
 * Local Card shim — Card left @archieai/ui's main exports at 2.8.x
 * (same casualty class as Select; mirrors the PostHogWidget shim).
 * Accepts and ignores the 2.3.0 variant/padding props for compatibility.
 */
export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: string;
  padding?: string;
}

export function Card({ className, children, variant: _variant, padding: _padding, ...divProps }: CardProps) {
  return (
    <div
      className={`bg-white border border-[var(--color-gray-200)] rounded-xl shadow-md p-4 ${className ?? ''}`}
      {...divProps}
    >
      {children}
    </div>
  );
}
